// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#total[data-v-bfe58f96] {\n    background-color: var(--very-light-gray);\n    padding: 10px;\n    border-bottom: var(--border-gray) solid 1px;\n}\n.adjustment[data-v-bfe58f96] {\n    color: var(--maroon-red);\n}\n", ""]);
// Exports
module.exports = exports;
